import axios from 'axios'

import {
  requestErrorInterceptor,
  requestInterceptor,
  responseErrorInterceptor,
  responseInterceptor
} from './interceptors'

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL
})

instance.interceptors.response.use(responseInterceptor, responseErrorInterceptor)

instance.interceptors.request.use(requestInterceptor, requestErrorInterceptor)

export const apiClient = instance
